export default "__VITE_ASSET__BOopIYFn__"